import {Theme} from '@innowise-group/ui-kit';
import {WorkspaceBookType, WorkspaceStatuses} from '@innowise-group/core';

export const proceedAttendanceBadgeVisibility = (attendancePercentage: number, status: WorkspaceBookType) => {
  const isValidPercentage =
    attendancePercentage !== undefined &&
    attendancePercentage !== null &&
    !isNaN(attendancePercentage) &&
    attendancePercentage >= 0 &&
    attendancePercentage <= 100;

  const isValidStatus = status === WorkspaceStatuses.Reserved || status === WorkspaceStatuses.Occupied;

  return isValidStatus && isValidPercentage;
};

export const getAttendanceBadgeColor = (attendancePercentage: number, {palette: {attendanceBadge}}: Theme) => {
  if (attendancePercentage >= 0 && attendancePercentage <= 49) {
    return attendanceBadge.redZone;
  }

  if (attendancePercentage >= 50 && attendancePercentage <= 79) {
    return attendanceBadge.yellowZone;
  }

  if (attendancePercentage >= 80 && attendancePercentage <= 100) {
    return attendanceBadge.greenZone;
  }
  return attendanceBadge.greyZone;
};
